import Vue from 'vue'
import jwtDecode from 'jwt-decode'
import router from './../router'
import deepcopy from 'deepcopy'
import { getToken, setToken, clearToken } from './../helpers/auth-storage'
import { getAccessTokenFromResponse, logoutRemote } from './../helpers/auth-client'

export default {
  loadNewsReport ({ commit }, dates) {
    return Vue.axios.post('usefuls/news/csv-report', { dates })
    .then(({data}) => {
      const win = window.open(data, '_blank')
      if (win) {
        win.focus()
      }
    })
  },
  getAccount ({ commit }) {
    return Vue.axios.get('account')
    .then(() => {
      const activeToken = getToken()
      if (!activeToken) {
        throw new Error('missing token')
      }
      commit('SET_USER', (jwtDecode(activeToken).user))
    })
  },
  getSettings ({ commit }) {
    return Vue.axios.get('settings')
    .then(({ data }) => commit('SET_SETTINGS', data))
  },
  getCommonServices ({ commit }) {
    Vue
      .axios
      .get('common-services')
      .then(res => commit('SET_COMMON_SERVICES', res.data))
  },
  addCommonServices ({ state, commit }, data) {
    Vue
      .axios
      .post('common-services', { commonServices: data })
      .then(res => {
        const values = deepcopy(state.commonServices)

        values.push(res.data)

        commit('SET_COMMON_SERVICES', values)
      })
  },
  photoUploadCommonServices ({ state, commit }, { formData, id }) {
    return Vue
      .axios
      .post('common-services/upload-photo', formData)
      .then(res => {
        let values = deepcopy(state.commonServices)
        const foundIndex = values.findIndex(
          el => el.id === id
        )

        values[foundIndex].photo = res.data.filename

        commit('SET_COMMON_SERVICES', values)

        return values[foundIndex]
      })
  },
  rmCommonServices ({ state, commit }, id) {
    Vue
      .axios
      .delete(`common-services/${id}`)
      .then(res => {
        const filtred = state.commonServices.filter(el => el.id !== id)
        commit('SET_COMMON_SERVICES', filtred)
      })
  },
  saveSettings ({ commit, dispatch, state }, settings) {
    settings = settings || state.settings
    let aboutGrottbjornPhoto
    let mainPagePhoto
    if (settings.aboutGrottbjornPhoto && settings.aboutGrottbjornPhoto.base64photo) {
      aboutGrottbjornPhoto = settings.aboutGrottbjornPhoto.data
      delete settings.aboutGrottbjornPhoto
    }
    if (settings.mainPagePhoto && settings.mainPagePhoto.base64photo) {
      mainPagePhoto = settings.mainPagePhoto.data
      delete settings.mainPagePhoto
    }

    const settingsToSave = { ...settings }
    delete settingsToSave.newDepositoryConsentFile
    delete settingsToSave.newPolicyFile
    if (settings.newPolicyFile) {
      delete settingsToSave.securityPolicyFile
    }
    if (settings.newDepositoryConsentFile) {
      delete settingsToSave.depositoryConsentFile
    }

    return Vue.axios.put('settings', { settings: settingsToSave })
    .then(() => {
      const documentUploads = []
      if (settings.newAgreementFile) {
        dispatch('loadAgreementFile', settings.newAgreementFile)
      }
      if (settings.newPolicyFile) {
        documentUploads.push(dispatch('loadPolicyFile', settings.newPolicyFile))
      }
      if (settings.newInfoMailingFile) {
        dispatch('loadInfoMailingFile', settings.newInfoMailingFile)
      }
      if (aboutGrottbjornPhoto) {
        dispatch('loadAboutGrottbjornPhoto', { formData: aboutGrottbjornPhoto, id: settings.id })
      }
      if (mainPagePhoto) {
        dispatch('loadMainPagePhoto', { formData: mainPagePhoto, id: settings.id })
      }
      if (settings.newDepositoryConsentFile) {
        documentUploads.push(dispatch('loadDepositoryConsentFile', settings.newDepositoryConsentFile))
      }
      return Promise.all(documentUploads)
    })
  },
  updateSettings ({ commit }, settings) {
    commit('UPDATE_SETTINGS', settings)
  },
  addAboutGrottbjornPhoto ({ commit }, settings) {
    commit('ADD_ABOUT_PHOTO', settings)
  },
  changePolicyFile ({ commit }, file) {
    commit('CHANGE_POLICY_FILE', file)
  },
  changeAgreementFile ({ commit }, file) {
    setTimeout(() => { commit('CHANGE_AGREEMENT_FILE', file) }, 200)
  },
  changeInfoMailingFile ({ commit }, file) {
    setTimeout(() => { commit('CHANGE_INFO_MAILING_FILE', file) }, 200)
  },
  loadPolicyFile ({ commit }, formData) {
    return Vue.axios.post(`settings/policy-file`, formData)
      .then(({ data }) => {
        commit('CHANGE_POLICY_FILE', data.securityPolicyFile)
        commit('UPDATE_SETTINGS', { newPolicyFile: null })
      })
  },
  deletePolicyFile ({ commit }) {
    commit('CHANGE_POLICY_FILE', '')
    commit('UPDATE_SETTINGS', { newPolicyFile: null })
  },
  loadAgreementFile ({ commit }, formData) {
    return Vue.axios.post(`settings/agreement-file`, formData)
    .then(({data}) => commit('CHANGE_AGREEMENT_FILE', data))
  },
  deleteAgreementFile ({ commit }) {
    commit('CHANGE_AGREEMENT_FILE', '')
  },
  loadInfoMailingFile ({ commit }, formData) {
    return Vue.axios.post(`settings/info-mailing-file`, formData)
      .then(({ data }) => commit('CHANGE_INFO_MAILING_FILE', data))
  },
  deleteInfoMailingFile ({ commit }) {
    commit('CHANGE_INFO_MAILING_FILE', '')
  },
  changeDepositoryConsentFile ({ commit }, file) {
    commit('CHANGE_DEPOSITORY_CONSENT_FILE', file)
  },
  loadDepositoryConsentFile ({ commit }, formData) {
    return Vue.axios.post('settings/depository-consent-file', formData)
      .then(({ data }) => {
        commit('CHANGE_DEPOSITORY_CONSENT_FILE', data.depositoryConsentFile)
        commit('UPDATE_SETTINGS', { newDepositoryConsentFile: null })
      })
  },
  deleteDepositoryConsentFile ({ commit }) {
    commit('CHANGE_DEPOSITORY_CONSENT_FILE', '')
    commit('UPDATE_SETTINGS', { newDepositoryConsentFile: null })
  },
  addFooterItem ({ commit }, data) {
    commit('ADD_FOOTER_ITEM', data)
  },
  deleteFooterItem ({ commit }, id) {
    commit('DELETE_FOOTER_ITEM', id)
  },
  updateFooterItem ({ commit }, item) {
    commit('UPDATE_FOOTER_ITEM', item)
  },
  updateAllFooterItems ({ commit }, items) {
    commit('UPDATE_FOOTER_ITEMS', items)
  },
  loadMainPagePhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`settings/main-page/change-photo/${id}`, formData)
  },
  login ({ commit }, credentials) {
    return Vue.axios.post('account', credentials)
    .then(({ data }) => {
      const accessToken = getAccessTokenFromResponse(data)
      if (!accessToken) {
        throw new Error('Missing access token in login response')
      }
      setToken(accessToken)
      Vue.axios.defaults.headers.common['Authorization'] = `JWT ${accessToken}`
      commit('SET_USER', data.user || (jwtDecode(accessToken).user))
    })
  },
  async logout ({ commit }) {
    await logoutRemote()
    clearToken()
    delete Vue.axios.defaults.headers.common['Authorization']
    commit('SET_USER', null)
    if (router.currentRoute.name !== 'Login') {
      router.push({ name: 'Login' })
    }
  },
  getSortedServices ({ commit }) {
    return Vue.axios.get('services/sorted')
    .then(({ data }) => commit('ADD_SERVICES', data))
  },
  saveMainPage ({ state }) {
    state.commonServices.forEach(
      el => Vue.axios.put('common-services', { commonServices: el })
    )
    // return Vue.axios.post('services/update-order', { data })
    // .then(() => dispatch('saveSettings'))
    // .then(() => {
    //   const withNewPhotos = data.filter(p => typeof p.mainPagePhoto === 'object' && p.mainPagePhoto !== null)
    //   return withNewPhotos.reduce(
    //     (p, v) => p.then((a) => dispatch('loadServiceMainPagePhoto', { formData: v.mainPagePhoto.data, id: v.id }).then(r => a.concat([r]))),
    //     Promise.resolve([])
    //   )
    // })
  },
  updateServiceItemsOrder ({ commit }, data) {
    commit('UPDATE_SERVICE_ITEMS_ORDER', data)
  },
  loadServiceMainPagePhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`services/change-main-page-photo/${id}`, formData)
  },
  loadReviewPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`services/review/${id}/change-photo`, formData)
    .then(({ data }) => commit('CHANGE_REVIEW_PHOTO', data))
  },
  getServices ({ commit, dispatch }, id) {
    return Vue.axios.get('services')
    .then(({ data }) => {
      commit('ADD_SERVICES', data)
      if (data[0] && !id) {
        dispatch('getService', data[0].id)
      }
    })
  },
  getService ({ commit }, id) {
    return Vue.axios.get(`services/${id}`)
    .then(({ data }) => commit('ADD_SERVICE', data))
  },
  getPromosForServices ({ commit }) {
    return Vue.axios.get(`services/promos`)
    .then(({ data }) => commit('ADD_SERVICE_PROMOS', data))
  },
  deleteService ({ state, commit }) {
    return Vue.axios.delete(`services/${state.service.id}`)
    .then(({ data }) => {
      commit('DELETE_SERVICE')
      if (state.services && state.services[0]) {
        commit('ADD_SERVICE', state.services[0])
        router.push(`/services/${state.service.id}`)
      }
    })
  },
  addAdvantage ({ commit }, data) {
    commit('ADD_ADVANTAGE', data)
  },
  addExtraAdvantage ({ commit }, data) {
    commit('ADD_EXTRA_ADVANTAGE', data)
  },
  deleteExtraAdvantage ({ commit }, id) {
    commit('DELETE_EXTRA_ADVANTAGE', id)
  },
  deleteAdvantage ({ commit }, id) {
    commit('DELETE_ADVANTAGE', id)
  },
  updateAdvantage ({ commit }, advantage) {
    commit('UPDATE_ADVANTAGE', advantage)
  },
  updateExtraAdvantage ({ commit }, data) {
    commit('UPDATE_EXTRA_ADVANTAGE', data)
  },
  updatePrinciple ({ commit }, principle) {
    commit('UPDATE_PRINCIPLE', principle)
  },
  addPrinciple ({ commit }, data) {
    commit('ADD_PRINCIPLE', data)
  },
  deletePrinciple ({ commit }, id) {
    commit('DELETE_PRINCIPLE', id)
  },
  updateReview ({ commit }, review) {
    commit('UPDATE_REVIEW', review)
  },
  addService ({ commit }) {
    router.push({ name: 'Service', params: { id: 'new' } })
    commit('ADD_NEW_SERVICE')
  },
  updateService ({ commit }, service) {
    commit('UPDATE_SERVICE_ITEM', service)
  },
  updateServiceOrder ({ commit }, service) {
    commit('UPDATE_SERVICE_ORDER', service)
  },
  saveService ({ commit, dispatch }, service) {
    let method = service.id === 'new' ? 'post' : 'put'
    service.promo_id = service.promo_id ? service.promo_id : null
    return Vue.axios[method]('services', { service })
    .then(({ data }) => {
      service.id = data.id
      commit('UPDATE_SERVICE', service)
      if (service.newPhoto) {
        dispatch('loadServicePhoto', { formData: service.newPhoto, id: service.id })
      }
      if (service.newRatesComparisonFile) {
        dispatch('loadRatesComparisonFile', { formData: service.newRatesComparisonFile, id: service.id })
      }
      for (const review of service.reviews) {
        if (review.newPhoto) {
          dispatch('loadReviewPhoto', { formData: review.newPhoto, id: review.id })
        }
      }
      if (method === 'post') {
        router.push({ name: 'Service', params: { id: service.id } })
      }
    })
  },
  changeRatesComparisonFile ({ commit }, file) {
    setTimeout(() => { commit('CHANGE_RATES_FILE', file) }, 200)
  },
  loadServicePhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`services/change-photo/${id}`, formData)
    .then(({ data }) => commit('LOAD_SERVICE_PHOTO', data))
  },
  loadRatesComparisonFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`services/change-rates-file/${id}`, formData)
  },
  addRate ({ commit, state }, data) {
    commit('ADD_RATE', data)
  },
  deleteRate ({ commit, state }, id) {
    commit('DELETE_RATE', id)
  },
  updateRate ({ commit }, rate) {
    commit('UPDATE_RATE', rate)
  },
  addReview ({ commit, state }, data) {
    commit('ADD_REVIEW', data)
  },
  deleteReview ({ commit }, id) {
    commit('DELETE_REVIEW', id)
  },
  getPromos ({ commit }, id) {
    return Vue.axios.get(`promos`)
    .then(({ data }) => commit('ADD_PROMOS', data))
  },
  addPromo ({ commit }, promo) {
    commit('ADD_NEW_PROMO', promo)
  },
  deletePromo ({ commit }, id) {
    return Vue.axios.delete(`promos/${id}`)
    .then(() => commit('DELETE_PROMO', id))
  },
  loadPromoPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`promos/change-photo/${id}`, formData)
    .then(({ data }) => commit('CHANGE_PROMO_PHOTO', data))
  },
  deletePromoPhoto ({ commit }, id) {
    return Vue.axios.delete(`promos/change-photo/${id}`)
    .then(({ data }) => commit('CHANGE_PROMO_PHOTO', data))
  },
  savePromo ({dispatch}, promo) {
    return Vue.axios.put(`promos`, { promo })
  },
  updatePromo ({ commit }, promo) {
    commit('UPDATE_PROMO', promo)
  },
  updateBecomeClientData ({ commit }, data) {
    commit('UPDATE_BECOME_CLIENT_DATA', data)
  },
  deleteBecomeClientData ({ commit }, id) {
    commit('DELETE_BECOME_CLIENT_DATA', id)
  },
  addBecomeClientData ({ commit }) {
    commit('ADD_BECOME_CLIENT_DATA')
  },
  getNotifications ({ commit }) {
    return Vue.axios.get('usefuls/news')
    .then(({ data }) => commit('ADD_NOTIFICATIONS', data))
  },
  getClients ({ commit }) {
    return Vue.axios.get('usefuls/news/clients')
    .then(({ data }) => commit('ADD_CLIENTS', data))
  },
  saveArticle ({ commit, dispatch }, article) {
    let [ url, method ] = article.id
      ? [ `usefuls/news/${article.id}`, 'PUT' ]
      : [ `usefuls/news`, 'POST' ]
    return Vue.axios({ method, url, data: article })
    .then(() => dispatch('getNotifications'))
  },
  deleteArticle ({ commit }, id) {
    return Vue.axios.delete(`usefuls/news/${id}`)
    .then(() => commit('DEL_NOTIFICATIONS', id))
  },
  getEvents ({ commit }) {
    return Vue.axios.get('usefuls/events')
    .then(({ data }) => commit('ADD_EVENTS', data))
  },
  getEmitents ({ commit }) {
    return Vue.axios.get('usefuls/events/emitents')
    .then(({ data }) => commit('ADD_EMITENTS', data))
  },
  saveEmitentEvent ({ commit, dispatch }, event) {
    let [ url, method ] = event.id
      ? [ `usefuls/events/${event.id}`, 'PUT' ]
      : [ `usefuls/events`, 'POST' ]
    let data = new FormData()
    data.append('event', JSON.stringify(event))
    data.append('pdf', event.file.file)
    if (method === 'POST') {
      commit('ADD_NEW_DEPONENTS_DATA', event)
    }
    return Vue.axios({ method, url, data })
  },
  deleteEvents ({ commit }, events) {
    return Vue.axios.delete(`usefuls/events`, { params: { toDelete: JSON.stringify(events) } })
    .then(() => commit('DEL_EVENTS', events))
  },
  getSoftware ({ commit }) {
    return Vue.axios.get('usefuls/software')
    .then(({ data }) => commit('SET_SOFTWARE', data))
  },
  saveSoftwarePackage ({ commit, dispatch }, pack) {
    let [ url, method ] = pack.id
      ? [ `usefuls/software/${pack.id}`, 'PUT' ]
      : [ `usefuls/software`, 'POST' ]
    return Vue.axios({ method, url, data: pack })
    .then(() => dispatch('getSoftware'))
  },
  deleteSoftwarePackage ({ commit }, id) {
    return Vue.axios.delete(`usefuls/software/${id}`)
    .then(() => commit('DEL_SOFTWARE_PACKAGE', id))
  },
  getApps ({ commit }) {
    return Vue.axios.get('usefuls/software/apps')
    .then(({ data }) => commit('SET_SOFTWARE_APPS', data))
  },
  saveApp ({ commit, dispatch }, { app, toDelete }) {
    let [ url, method ] = app.id
      ? [ `usefuls/software/apps/${app.id}`, 'PUT' ]
      : [ `usefuls/software/apps`, 'POST' ]
    let data = new FormData()
    data.append('app', JSON.stringify(app))
    data.append('toDelete', JSON.stringify(toDelete))
    app.files.forEach(file => {
      if (file.file) {
        data.append((file.id || file.title), file.file)
      }
    })
    return Vue.axios({ method, url, data })
    .then(() => {
      dispatch('getApps')
    })
  },
  deleteApp ({ commit }, id) {
    return Vue.axios.delete(`usefuls/software/apps/${id}`)
    .then(() => commit('DEL_SOFTWARE_APP', id))
  },
  addFile ({ commit }, { appId, file }) {
    commit('ADD_FILE', { appId, file })
  },
  deleteFile ({ commit, dispatch }, id) {
    return Vue.axios.delete(`usefuls/software/files/${id}`)
    .then(() => dispatch('getApps'))
  }, /* temporary files storage */
  loadFilesStorage ({ commit }) {
    return Vue.axios.get(`files`)
    .then(({data}) => commit('LOAD_FILES_STORAGE', data))
  },
  saveFile ({ dispatch }, file) {
    let data = new FormData()
    data.append('file', file)
    return Vue.axios.post('files', data)
    .then(_ => {
      dispatch('loadFilesStorage')
    })
  },
  delFile ({ dispatch }, filename) {
    return Vue.axios.delete(`files/${filename}`)
    .then(_ => dispatch('loadFilesStorage'))
  },
  getClaimInfo ({ commit }) {
    return Vue
      .axios
      .get('claim-info')
      .then(({ data }) => {
        commit('SET_CLAIM_INFO', data)
      })
  },
  updateClaimInfo ({ commit }, updatedClaimInfo) {
    commit('UPDATE_CLAIM_INFO', updatedClaimInfo)
  },
  getClaims ({ commit }) {
    return Vue
      .axios
      .get('claims')
      .then(({ data }) => {
        commit('SET_CLAIMS', data)
      })
  },
  addClaim ({ commit }, claim) {
    return Vue
      .axios
      .post('claims/claim', claim)
      .then(({ data }) => {
        commit('ADD_CLAIM', data)
      })
  },
  updateClaim ({ commit }, updatedClaim) {
    commit('UPDATE_CLAIM', updatedClaim)
  },
  removeClaim ({ commit }, claimId) {
    return Vue
      .axios
      .delete(`claims/${claimId}`)
      .then(() => {
        commit('REMOVE_CLAIM', claimId)
      })
  },
  loadBrokers ({ commit }, file) {
    const data = new FormData()
    data.append('file', file)
    return Vue.axios.post('brokers', data)
  },
  saveUnderwritingPage ({ state, dispatch }) {
    return Vue
      .axios
      .post('claim-info', state.claimInfo)
      .then(() =>
        Vue
          .axios
          .post('claims', state.claims)
          .then(() => { dispatch('getClaims') })
      )
  },
  getSubmissionAppOperations ({ commit }) {
    return Vue
      .axios
      .get('submission-app-operations')
      .then(({ data }) => {
        commit('SET_APP_OPERATIONS', data)
      })
  },
  sendTimeForSync ({ commit }, time) {
    return Vue.axios.post('cron', { time })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js